import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=626e95cd&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=626e95cd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e95cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626e95cd')) {
      api.createRecord('626e95cd', component.options)
    } else {
      api.reload('626e95cd', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=626e95cd&scoped=true", function () {
      api.rerender('626e95cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/questionnaire/edit.vue"
export default component.exports